import React from 'react'
import './button.css'

function SidebarMenuItemButton({name, onClickHandler, color="primary", size="small"}) {
  return (
    <button className={`sidebar-menu-item`} onClick={onClickHandler}>{name}</button>
  )
}

export default SidebarMenuItemButton